import React from 'react';
import modal from '~components/modal';
import PropertyListEditorContent from '~components/special-offer/map/offer-map-by-property/property-list-editor/modal';

@modal(
  {
    className: 'property-list-editor-modal',
  },
  true,
)
export default class PropertyListEditor extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { onClose, specialOfferId, onSuccess } = this.props;
    return (
      <PropertyListEditorContent
        onClose={onClose}
        specialOfferId={specialOfferId}
        onSuccess={onSuccess}
      />
    );
  }
}
